import { createI18n } from 'vue-i18n'
import zh from './locales/zh'
import en from './locales/en'
import ja from './locales/ja'
import ko from './locales/ko'
import { SUPPORTED_LOCALES } from './constants/locales'

// 从URL中获取初始语言
export const getInitialLocale = () => {
  const path = window.location.pathname
  const firstSegment = path.split('/')[1]
  return SUPPORTED_LOCALES.includes(firstSegment) ? firstSegment : 'zh'
}

export default createI18n({
  legacy: false,
  locale: getInitialLocale(), // 根据URL设置初始语言
  fallbackLocale: 'zh',
  messages: {
    zh,
    en,
    ja,
    ko
  }
})